<template>
  <div 
    class="fill-height">
    <v-layout wrap>
      <v-flex>
        <v-dialog v-model="dialog.success"
          width="350">
          <v-card 
            class="border-radius pa-2">
            <v-card-text>
              <v-img 
                width="125"
                height="125"
                alt="kominfoklaten" 
                :src="require('@/assets/icon/info_berhasil.png')"
                class="ma-auto my-6">
                <template v-slot:placeholder>
                  <v-row
                    class="fill-height"
                    align="center"
                    justify="center">
                    <v-progress-circular 
                      size="20"
                      indeterminate 
                      :color="set_color">
                    </v-progress-circular>
                  </v-row>
                </template>
              </v-img>

              <div
                class="body-1 text-center line-text-second">
                <div>
                  Terima kasih, profil Anda
                </div>

                <div>
                  telah berhasil diubah!
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-dialog>

        <section>
          <v-card
            flat
            min-height="calc(100vh - 265px)"
            style="border-radius: 10px; border: 1px solid #E7E7E7; overflow-y: auto;">
            <v-card-text
              class="pt-3 pb-0">
              <div
                class="title font-weight-bold black--text mb-1">
                Ubah General
              </div>

              <div
                class="body-1 mb-4">
                Ubah atau lengkapi data profil Anda, dengan mengisi form dibawah ini:
              </div>
            </v-card-text>

            <v-divider
              class="my-4"
              style="border-top: 2px dashed #EBEBEB;" />
              
            <v-card-text
              class="pt-0">
              <ValidationObserver 
                ref="form">
                <v-form>
                  <div
                    class="mb-4">
                    <div 
                      class="body-2 mb-2">
                      Poto Profil
                    </div>

                    <uploadfolder v-if="form.image_url === ''"
                      v-model="upload.image">
                      <div 
                        slot="activator">
                        <v-card 
                          flat
                          width="200"
                          height="200"
                          class="d-flex align-center justify-center cursor-pointer"
                          style="border-radius: 15px;
                                border: 2px solid #EBEBEB; 
                                border-style: dashed;">
                          <v-avatar v-if="!process.image"
                            v-ripple
                            tile 
                            width="200"
                            height="200">
                            <v-icon
                              size="50"
                              color="#B9B9B9">
                              mdi-cloud-upload-outline
                            </v-icon>
                          </v-avatar>

                          <v-progress-circular v-else
                            indeterminate
                            :color="set_color">
                          </v-progress-circular>
                        </v-card>
                      </div>
                    </uploadfolder>

                    <v-card v-if="form.image_url !== ''"
                      flat
                      width="200"
                      height="200"
                      class="d-flex align-center justify-center"
                      style="border-radius: 15px;
                            border: 2px solid #EBEBEB; 
                            border-style: dashed;">
                      <v-avatar
                        v-ripple
                        tile 
                        size="200"
                        style="border-radius: 15px;">
                        <v-img 
                          contain
                          width="100%"
                          height="100%"
                          alt="kominfoklaten" 
                          :src="form.image_url"
                          class="ma-auto"
                          style="border-radius: 15px;">
                          <template v-slot:placeholder>
                            <v-row
                              class="fill-height"
                              align="center"
                              justify="center">
                              <v-progress-circular 
                                indeterminate 
                                :color="set_color">
                              </v-progress-circular>
                            </v-row>
                          </template>
                        </v-img>
                      </v-avatar>

                      <v-icon 
                        @click="form.image_url = ''"
                        color="red"
                        class="cursor-pointer"
                        style="position: absolute; top: -10px; right: -10px;">
                        mdi-close-circle
                      </v-icon>
                    </v-card>
                  </div>
                  
                  <v-row>
                    <v-col
                      cols="12"
                      md="6">
                      <ValidationProvider 
                        name="Nama Lengkap" 
                        rules="required" 
                        v-slot="{ errors, valid }">
                        <div class="body-2 mb-2">
                          <span class="red--text">*</span>

                          Nama Lengkap
                        </div>

                        <v-text-field
                          v-on:keyup.enter="save()"
                          
                          filled
                          rounded
                          dense
                          
                          :color="set_color"
                          placeholder="Contoh. John Doe"

                          :disabled="Object.keys(form).length < 1"

                          hide-details

                          v-model="form.name"
                          :success="valid"
                          :error-messages="errors"
                          required
                          style="border-radius: 10px;">
                          <template v-slot:append-outer>
                            <div v-if="errors.length > 0">
                              <v-tooltip top color="#ff5252">
                                <template v-slot:activator="{ on }">
                                  <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                </template>
                                
                                {{ errors[0] }}
                              </v-tooltip>
                            </div>
                            
                            <div v-if="form.name !== '' && valid">
                              <v-icon color="success">mdi-check-circle-outline</v-icon>
                            </div>
                          </template>
                        </v-text-field>
                      </ValidationProvider>
                    </v-col>

                    <v-col
                      cols="12"
                      md="6">
                      <ValidationProvider 
                        name="Nomor Induk Pegawai" 
                        rules="required" 
                        v-slot="{ errors, valid }">
                        <div class="body-2 mb-2">
                          <span class="red--text">*</span>

                          Nomor Induk Pegawai
                        </div>

                        <v-text-field
                          v-on:keyup.enter="save()"
                          
                          filled
                          rounded
                          dense
                          
                          :color="set_color"
                          placeholder="Contoh. 3102XXX"
                          
                          :disabled="Object.keys(form).length < 1"

                          hide-details

                          v-model="form.nip"
                          :success="valid"
                          :error-messages="errors"
                          required
                          style="border-radius: 10px;">
                          <template v-slot:append-outer>
                            <div v-if="errors.length > 0">
                              <v-tooltip top color="#ff5252">
                                <template v-slot:activator="{ on }">
                                  <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                </template>
                                
                                {{ errors[0] }}
                              </v-tooltip>
                            </div>
                            
                            <div v-if="form.nip !== '' && valid">
                              <v-icon color="success">mdi-check-circle-outline</v-icon>
                            </div>
                          </template>
                        </v-text-field>
                      </ValidationProvider>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col
                      cols="12"
                      md="6">
                      <ValidationProvider 
                        name="Email" 
                        rules="required|email" 
                        v-slot="{ errors, valid }">
                        <div class="body-2 mb-2">
                          <span class="red--text">*</span>

                          Email
                        </div>

                        <v-text-field
                          v-on:keyup.enter="save()"
                          
                          filled
                          rounded
                          dense

                          disabled

                          :color="set_color"
                          placeholder="Contoh. XXXX@gmail.com"

                          hide-details

                          v-model="form.email"
                          :success="valid"
                          :error-messages="errors"
                          required
                          style="border-radius: 10px;">
                          <template v-slot:append-outer>
                            <div v-if="errors.length > 0">
                              <v-tooltip top color="#ff5252">
                                <template v-slot:activator="{ on }">
                                  <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                </template>
                                
                                {{ errors[0] }}
                              </v-tooltip>
                            </div>
                            
                            <div v-if="form.email !== '' && valid">
                              <v-icon color="success">mdi-check-circle-outline</v-icon>
                            </div>
                          </template>
                        </v-text-field>
                      </ValidationProvider>
                    </v-col>
                    
                    <v-col
                      cols="12"
                      md="6">
                      <ValidationProvider 
                        name="Mobilephone" 
                        rules="required|min:10|max:13" 
                        v-slot="{ errors, valid }">
                        <div class="body-2 mb-2">
                          <span class="red--text">*</span>

                          Mobilephone
                        </div>

                        <v-text-field
                          v-on:keyup.enter="save()"
                          
                          filled
                          rounded
                          dense

                          onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                          type="number"
                          min="0"

                          :color="set_color"
                          placeholder="Contoh. 081XXXXXXXXX"

                          hide-details

                          v-model="form.mobilephone"
                          :success="valid"
                          :error-messages="errors"
                          required
                          style="border-radius: 10px;">
                          <template v-slot:append-outer>
                            <div v-if="errors.length > 0">
                              <v-tooltip top color="#ff5252">
                                <template v-slot:activator="{ on }">
                                  <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                </template>
                                
                                {{ errors[0] }}
                              </v-tooltip>
                            </div>
                            
                            <div v-if="form.mobilephone !== '' && valid">
                              <v-icon color="success">mdi-check-circle-outline</v-icon>
                            </div>
                          </template>
                        </v-text-field>
                      </ValidationProvider>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col
                      cols="12"
                      md="6">
                      <ValidationProvider
                        name="Jenis Kelamin" 
                        rules="required" 
                        v-slot="{ errors, valid }">
                        <div class="body-2 mb-2">
                          <span class="red--text">*</span>
                          Jenis Kelamin
                        </div>

                        <v-select
                          v-on:keyup.enter="save()"
                          
                          filled
                          rounded
                          dense

                          :color="set_color"
                          placeholder="Contoh. Laki-Laki"

                          hide-details
                          
                          :items="['Laki-Laki', 'Perempuan']"
                          :item-color="set_color"

                          v-model="form.gender"
                          :success="form.gender !== '' && valid"
                          :error-messages="errors"
                          required
                          style="border-radius: 10px;">
                          <template v-slot:append-outer>
                            <div v-if="errors.length > 0">
                              <v-tooltip top color="#ff5252">
                                <template v-slot:activator="{ on }">
                                  <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                </template>
                                
                                {{ errors[0] }}
                              </v-tooltip>
                            </div>

                            <div v-if="form.gender !== '' && valid">
                              <v-icon color="success">mdi-check-circle-outline</v-icon>
                            </div>
                          </template>
                        </v-select>
                      </ValidationProvider>
                    </v-col>
                  </v-row>
                </v-form>
              </ValidationObserver>

              <div v-if="message.error.length > 0"
                class="text-center my-4 d-flex align-center">
                <div
                  class="error--text">
                  <v-icon size="18" color="red">mdi-alert-circle-outline</v-icon>
                  
                  <span
                    class="ml-1">
                    {{ message.error }}
                  </span>
                </div>
              </div>
            </v-card-text>
          </v-card>

          <v-row
            justify="end"
            class="pa-4 pr-1 mt-3">
            <v-col 
              cols="2"
              class="py-0">
              <v-btn
                @click="save()"
                :loading="process.form"
                :disabled="process.form"
                block
                color="#4B4B4B"
                elevation="0"
                class="body-2 white--text text-capitalize d-flex align-center"
                style="border-radius: 10px; font-weight: 600; background: linear-gradient(180deg, rgba(63, 148, 62, 1), rgba(22, 115, 20, 1));">
                <v-icon size="20">mdi-checkbox-marked-circle-outline</v-icon>
                
                <span
                  class="ml-2">
                  Simpan
                </span>
              </v-btn>
            </v-col>
          </v-row>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { TokenService } from "@/service/Storage.Service";
  import { get, post, put, patch, destroy } from "@/service/Axios";
  export default {
    props: {
      form: {
        type: Object,
        default: {}
      }
    },
    data () {
      return {
        dialog: {
          success: false
        },

        upload: {
          image: null
        },

        process: {
          form: false,

          image: false
        },
        message: {
          success: '',
          error: ''
        }
      }
    },
    components: {
      uploadfolder: () => import(/* webpackPrefetchCategory: true */ '@/components/upload/folder.vue')
    },
    watch: {
      'upload.image': {
        handler: function () {
          if (this.upload.image) {
            this.process.image = this.upload.image.process

            if (!this.process.image) {
              // CALLBACK FROM UPLOAD IMAGE
              
              this.form.image_url = this.upload.image.fileuri

              this.save_image()
            }
          }
        },
        deep: true
      }
    },
    computed: {
      rps () {
        return this.$vuetify.breakpoint.name
      },
      fcm () {
        return this.$store.state.fcm
      },
      isDay () {
        let hours = (new Date()).getHours(),
            day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
        return day
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
      },
      set_color_rgb_down () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.25)`
      }
    },
    mounted () {
      this.fetchDetail()
    },
    methods: {
      async fetchDetail () {
        await get(`admin/profile_user/detail`)
        .then(response => {
          let res = response.data

          this.process.load = false
            
          if (res.status === 200) {
            // this.form = res.results.data
            TokenService.saveToken(
              this.$store.state.token,
              JSON.stringify(res.results.data),
              JSON.stringify(this.$store.state.menu)
            )
            this.$store.state.user = res.results.data
          }
        })
      },
      async save () {
        this.message.error = ''

        const isValid = await this.$refs.form.validate()
        if (isValid) {
          this.process.form = true

          // SAVE TO REST API
          await post(`admin/profile_user/update`, {
            data: this.form
          })
          .then((response) => {
            let res = response.data

            this.process.form = false

            if (res.status === 200) {
              this.fetchDetail()
              // let user = {
              //   id: res.results.data.id,
                
              //   name: res.results.data.name,
              //   nip: res.results.data.user_nip,

              //   email: res.results.data.user_email,
              //   mobilephone: res.results.data.user_mobilephone,
                
              //   image_url: res.results.data.user_image_url,
              //   gender: res.results.data.user_gender
              // }

              // TokenService.saveToken(
              //   this.$store.state.token,
              //   JSON.stringify(user),
              //   JSON.stringify(this.$store.state.menu)
              // )

              // this.$store.state.user = user

              this.dialog.success = true
            } else {
              this.message.error = res.message
            }
          })
          
        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }
      },

      async save_image () {
        this.message.error = ''

        // SAVE TO REST API
        await post(`admin/profile_user/update`, {
          data: this.form
        })
        .then((response) => {
          let res = response.data

          if (res.status === 200) {
            let user = {
              id: this.form.id,
                
              name: this.form.name,
              nip: this.form.nip,

              email: this.form.email,
              mobilephone: this.form.mobilephone,
              
              image_url: this.form.image_url,
              gender: this.form.gender
            }

            TokenService.saveToken(
              this.$store.state.token,
              JSON.stringify(user),
              JSON.stringify(this.$store.state.menu)
            )

            this.$store.state.user = user
          } else {
            this.message.error = res.message
          }
        })
      }
    }
  }
</script>